interface Etapa {
  numero: string;
  titulo: string;
  descricao: string;
}

const etapas: Etapa[] = [
  {
    numero: '01',
    titulo: 'Primeiro Contato',
    descricao:
      'Realize o contato por telefone, WhatsApp ou formulário. Nossa equipe responde com agilidade e discrição.',
  },
  {
    numero: '02',
    titulo: 'Análise do Caso',
    descricao:
      'Realizamos uma análise jurídica criteriosa da situação, identificando riscos, oportunidades e o melhor caminho.',
  },
  {
    numero: '03',
    titulo: 'Estratégia Jurídica',
    descricao:
      'Desenvolvemos uma estratégia personalizada e eficaz, alinhada aos seus objetivos e à prevenção de riscos.',
  },
  {
    numero: '04',
    titulo: 'Acompanhamento',
    descricao:
      'Monitoramos e acompanhamos cada etapa do processo, mantendo você informado e seguro em todas as decisões.',
  },
];

const ComoAtuamosSection = () => {
  return (
    <section id="como-atuamos" className="py-16 md:py-28 bg-[#0F1E2E] relative overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-12 md:mb-20">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-px w-10 bg-[#C8A96A]" />
            <span className="text-[#C8A96A] text-xs font-semibold tracking-[0.35em] uppercase">
              Nossa Metodologia
            </span>
            <div className="h-px w-10 bg-[#C8A96A]" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-[#F9FAFB] mb-4">
            Como Atuamos
          </h2>
          <p className="text-[#E5E7EB]/60 text-sm md:text-base max-w-xl mx-auto font-light">
            Um processo claro, estruturado e eficiente para proteger seus interesses com
            máxima segurança jurídica.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5">
          {etapas.map((etapa, index) => (
            <div key={etapa.numero} className="bg-[#0F1E2E] p-10 relative group hover:bg-[#1E3A5F]/50 transition-colors duration-300">
              {/* Number */}
              <p className="text-[#C8A96A]/20 text-7xl font-bold mb-6 leading-none">
                {etapa.numero}
              </p>

              {/* Title */}
              <h3 className="text-[#F9FAFB] text-base font-semibold mb-3">{etapa.titulo}</h3>

              {/* Description */}
              <p className="text-[#E5E7EB]/50 text-sm leading-relaxed">{etapa.descricao}</p>

              {/* Connector line (except last) */}
              {index < etapas.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-px w-px h-12 bg-[#C8A96A]/20 -translate-y-1/2" />
              )}
            </div>
          ))}
        </div>

        {/* Bottom Quote */}
        <div className="mt-14 md:mt-20 text-center border-t border-white/5 pt-10 md:pt-16">
          <blockquote className="text-[#E5E7EB]/70 text-base md:text-lg font-light italic max-w-2xl mx-auto leading-relaxed px-4">
            "Atendimento com <span className="text-[#C8A96A] not-italic font-medium">seriedade</span> e{' '}
            <span className="text-[#C8A96A] not-italic font-medium">confidencialidade</span>,
            do primeiro contato à resolução definitiva."
          </blockquote>
        </div>
      </div>
    </section>
  );
};

export default ComoAtuamosSection;
